export enum ParamType {
    storedBimsyncModelId = 'storedBimsyncModelId',
    storedSelectedExpiryType = 'storedSelectedExpiryType',
    storedSelectedPortfolio = 'storedSelectedPortfolio',
    storedSelectedRegion = 'storedSelectedRegion',

    byggNummer = 'byggNummer',
    invoiceListFilter = 'invoiceListFilter',
    isAdmin = 'isAdmin',
    lang = 'lang',
    kundeNummer = 'kundeNummer',
    messageId = 'messageId',
    messageListFilter = 'messageListFilter',
    tab = 'tab',
    selectedClient = 'selectedClient',
    referrer = 'referrer',
    sakId = 'sakId',
    contractPath = 'contractPath',
    dxboPath = 'dxboPath',
    menuPin = 'menuPin',
}
